import { useFormContext } from "react-hook-form";

import DwellingAssociateBuildingForm from "@/modules/dwelling/components/DwellingAssociateBuildingForm.tsx";

import Input from "../Input.tsx";
import SearchAddress from "../SearchAddress.tsx";


const InformationsPropertyForm = () => {
  const { control, getValues } = useFormContext();

  return (
    <div className="bg-container d-flex flex-column gap-3">
      <h3 className="fw-bold main-title" style={{ fontSize: "24px" }}>
        Informations sur le bien
      </h3>
      <div className="row">
        <SearchAddress
          control={control}
          defaultAddress={getValues("address.address") ?? undefined}
          name={"address.address"}
          rules={{ required: "veuillez indiquer une adresse" }}
          label="Adresse postale"
          isDisabled={false}
        />
      </div>
      <div className={"row"}>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Nom de la résidence :"
            name="address.residenceName"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Digicode :"
            name="address.digicode"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Bâtiment :"
            name="address.buildingNumber"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Escalier :"
            name="address.stair"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Niveau :"
            rules={{ required: "Le niveau est requis" }}
            name="address.floor"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Entrée :"
            name="address.entry"
            control={control}
            defaultValue=""
          />
        </div>
      </div>
      <div className={"row"}>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="Porte :"
            name="address.door"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="N° de cave :"
            name="address.cellarNumber"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="N° parking ext. :"
            name="address.outdoorParkingNumber"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="N° parking int. :"
            name="address.indoorParkingNumber"
            control={control}
            defaultValue=""
          />
        </div>
        <div className="col d-flex flex-column align-items-start">
          <Input
            label="N° box garage :"
            name="address.garageBoxNumber"
            control={control}
            defaultValue=""
          />
        </div>
      </div>
      <div className={"row"}>
        <DwellingAssociateBuildingForm control={control} name={"building"} />
      </div>
    </div>
  );
};

export default InformationsPropertyForm;
